import { PropsWithChildren } from "react";
import { AnimatedCurtain } from "./curtain";
import { AnimatePresence } from "motion/react";

type TransitionCurtainProps = {
  isEnabled?: boolean;
  pageKey?: string;
  isOpenAnimationDisabled?: boolean;
  direction?: "up" | "down";
  onClose?: () => void;
};

export const TransitionCurtain = ({
  children,
  isEnabled,
  isOpenAnimationDisabled,
  onClose,
  pageKey: elementKey,
  direction = "up",
}: PropsWithChildren<TransitionCurtainProps>) => {
  return (
    <AnimatePresence
      mode={isEnabled ? "wait" : undefined}
      custom={{
        isEnabled,
        onClose,
        isOpenAnimationDisabled,
        direction,
      }}
    >
      <AnimatedCurtain key={elementKey}>{children}</AnimatedCurtain>
    </AnimatePresence>
  );
};
